/**
 * Created by Ning Jiang on 2023-11-06.
 */
import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {TimelineLite} from "gsap";

export class SymbolLandingController extends ReelStopPresentationController {

    private _holdPromise:Promise<any>;
    private _landingTls:TimelineLite[] = [];

    constructor() {
        super("SymbolLandingController");
    }

    public async start():Promise<any> {
        await super.start();
        const tlPromises:Promise<any>[] = [];
        this._landingTls.forEach(tl => {
            if(tl.totalDuration() > 0 && tl.progress() < 1) {
                tlPromises.push(Promise.resolve(tl));
            }
        });
        await Promise.all(tlPromises);
    }

    public addLanding(tl:TimelineLite):void {
        this._landingTls.push(tl);
    }

    protected reset() {
        this._landingTls = [];
        super.reset();
    }
}